import React, { useState, useEffect } from 'react';
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  EditButton,
  Filter,
  SearchInput,
  SimpleList,
  CreateButton,
  ShowButton,
  DeleteButton,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin';
import { useMediaQuery } from '@material-ui/core';
import { Card, CardContent, Typography, Box, Button, Grid, TextField as MuiTextField } from '@material-ui/core';

const SalesPackingFilter = (props: any) => (
  <Filter {...props} variant="outlined">
    <SearchInput label="Sales Bill No" source="billNo~like" alwaysOn />
    <SearchInput label="Order No" source="order.orderNo~like" alwaysOn />
  </Filter>
);

export const SalesPackingList = (props: any) => {
  const propsObj: any = { ...props };
  const isSmall = useMediaQuery((theme: any) => theme.breakpoints.down('sm'));

  if (propsObj.permissions) {
    const resourcename = `/${props.resource}`;
    const myPermissions = propsObj.permissions.filter((item: any) => item.NavigateUrl.toLowerCase().trim() === resourcename);
    if (myPermissions.length > 0) {
      const p = myPermissions[0];
      propsObj.hasList = p.View === 1;
      propsObj.hasShow = p.View === 1;
      propsObj.hasEdit = p.Edit === 1;
      propsObj.hasDelete = p.Delete === 1;
      propsObj.hasCreate = p.Create === 1;
      propsObj.hasExport = p.Export === 1;
    }
  }

  return (
    <React.Fragment>
      <List
        {...propsObj}
       // exporter={propsObj.hasExport}
        bulkActionButtons={false}
         exporter={false}
        title="Sales Packing"
        filters={<SalesPackingFilter />}
         sort={{ field: 'createdDate', order: 'DESC' }}
      >
        {isSmall ? (
          <SimpleList
            primaryText={(record: any) => record.billNo || ''}
            secondaryText={(record: any) => record.order?.orderNo || ''}
            // tertiaryText={(record: any) =>
            //   record.billDate ? `Date: ${new Date(record.billDate).toLocaleDateString()}` : ''
            // }
            linkType={propsObj.hasEdit ? 'edit' : 'show'}
          />
        ) : (
          <Datagrid rowClick={propsObj.hasEdit ? 'edit' : undefined}  className="salesPackingGrid">
            
            {propsObj.hasEdit && <EditButton />}
            {propsObj.hasDelete && <DeleteButton />}
            <TextField source="billNo" label="Sales Bill No" />
            <DateField source="billDate" label="Bill Date" locales="fr-FR" />
            <ReferenceField source="orderId" reference="orders" label="Order No" link={false}>
              <TextField source="orderNo" />
            </ReferenceField>
            <ReferenceField source="customerId" reference="customers" label="Customer" link={false}>
              <TextField source="name" />
            </ReferenceField>
            <TextField source="designCode" label="Design Code" />
            {/* <DateField source="createdDate" label="Created Date" locales="fr-FR" /> */}
          </Datagrid>
        )}
      </List>
    </React.Fragment>
  );
};
